export default __webpack_public_path__ + "static/media/rust_server.aa2dff19.jpg";